import React, { CSSProperties, useRef, useState } from "react";
import "./SettingCenter.css";
import BarcodeFormat from "./components/BarcodeFormat/BarcodeFormat";
import SelectMode from "./components/SelectMode/SelectMode";
import OtherSettings from "./components/OtherSettings/OtherSettings";
import AdvancedSettings from "./components/AdvancedSettings/AdvancedSettings";
import { RootStore } from "../../store/"
import { useSelector, useDispatch } from "react-redux";
import { updateState } from "../../store/features/generalStatesSlice";
import { DivRef } from "../../utils/typesAndMaps";

interface ControlCenterProps {
  settingsDivRef: DivRef,
  hideSettingsOrPanel: (type: string) => void
}

export default function SettingCenter({ settingsDivRef, hideSettingsOrPanel }: ControlCenterProps) {
  const toggleRef: DivRef = useRef(null);
  const settingsRef: DivRef = useRef(null);
  const [isAdvancedSettingsVisible, setAdvSettingsVisibility] = useState(false);

  const generalStates = useSelector((store: RootStore) => store.generalStates);
  const dispatch = useDispatch();

  const styles = {
    "--width": generalStates.settingsToggle ? "22px" : "330px",
    "--display": generalStates.settingsToggle ? "none" : "block",
    "--right": generalStates.settingsToggle ? "0" : "10px"
  } as CSSProperties;

  const showHideAdvancedSettings = () => {
    setAdvSettingsVisibility(!isAdvancedSettingsVisible);
  }

  return (
    <div className="dbr-setting-center" style={styles} ref={settingsDivRef}>
      <div className="dbr-setting-toggle" onClick={() => { dispatch(updateState({ stateName: "settingsToggle", value: !generalStates.settingsToggle })) }} ref={toggleRef}>
        {generalStates.settingsToggle ?
          <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6675" width="12" height="22"><path d="M353.045333 86.826667L754.56 488.362667a32 32 0 0 1 2.090667 42.965333l-2.090667 2.282667L353.066667 935.168a8.533333 8.533333 0 0 1-6.037334 2.496h-66.368a8.533333 8.533333 0 0 1-6.037333-14.570667L686.72 511.018667 274.602667 98.901333a8.533333 8.533333 0 0 1 6.037333-14.570666h66.346667a8.533333 8.533333 0 0 1 6.058666 2.496z" fill="#333333" p-id="6676"></path></svg>
          :
          <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5695" width="12" height="22"><path d="M670.954667 86.826667L269.44 488.362667a32 32 0 0 0-2.090667 42.965333l2.090667 2.282667L670.933333 935.168a8.533333 8.533333 0 0 0 6.037334 2.496h66.368a8.533333 8.533333 0 0 0 6.037333-14.570667L337.28 511.018667 749.397333 98.901333a8.533333 8.533333 0 0 0-6.037333-14.570666h-66.346667a8.533333 8.533333 0 0 0-6.058666 2.496z" fill="#333333" p-id="5696"></path></svg>
        }
      </div>
      <div className="dbr-setting-content" ref={settingsRef}>
        <BarcodeFormat />
        <SelectMode showHideAdvancedSettings={showHideAdvancedSettings} />
        <OtherSettings />
        <div className="dbr-advanced-settings-btn">
          <span onClick={showHideAdvancedSettings}>
            <span>Advanced Settings</span>
            <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9550" width="25" height="25"><path d="M880.48 451.488l-14.72-64 54.96-94.976-117.6-146.464-105.28 32L637.92 149.6 597.472 48H409.248l-40.464 101.6-59.904 28.544-105.28-32.064-117.616 146.448 54.96 94.976-14.72 64-90.976 61.872 42.016 182.864 108.944 16.512 41.312 51.456-8.016 109.216 169.696 80.976L470.064 880h66.592l80.864 74.4L787.2 873.328l-8-109.168 41.296-51.424 108.96-16.496 42-182.864-90.992-61.888z m-16.816 173.808l-86 13.056-80.576 100.32 6.336 86.16-71.664 34.08L567.808 800h-128.896l-63.968 58.912-71.664-34.176 6.336-86.112-80.576-100.304-86-13.04-17.568-76.528 71.696-48.768 28.8-125.28-43.296-74.832 49.424-61.552 83.248 25.328 116.224-55.408L463.52 128h79.664l31.952 80.24 116.224 55.488 83.248-25.36 49.424 61.536-43.296 74.816 28.8 125.28 71.712 48.752-17.6 76.544zM504.88 336c-92.64 0-167.968 75.36-167.968 168s75.36 168 168 168 168-75.36 168-168S597.536 336 504.88 336z m0.032 256a88.112 88.112 0 0 1-88-88c0-23.504 9.152-45.6 25.76-62.224A87.392 87.392 0 0 1 504.928 416c48.512 0 88 39.488 88 88s-39.488 88-88 88z" fill="#565D64" p-id="9551"></path></svg>
          </span>
        </div>
        <button className="dbr-ok-btn" onClick={() => { hideSettingsOrPanel("settings") }}>OK</button>
      </div>
      <AdvancedSettings settingsToggle={generalStates.settingsToggle} showHideAdvancedSettings={showHideAdvancedSettings} isAdvancedSettingsVisible={isAdvancedSettingsVisible} />
    </div>
  );
}